<template>
  <div class='config-text-row'>
    <span class='config-text-row__plan'>{{title}}</span>
    <span class='config-text-row__value'>{{value}}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: String
  }
}
</script>

<style lang='scss'>
@import '@zoom/billing-responsive/styles/responsive.scss';

.opc-capacity-config-row__capacity .config-text-row {
  margin: 0;
  padding: 0;
  min-width: 136px;

  @include media(mobile) {
    margin: 0;
    padding-left: 12px;
  }
}
.config-text-row {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 16px;
  padding-left: 16px;

  @include media(mobile) {
    margin: 0;
    padding-top: 12px;
    padding-left: 12px;
  }

  &__plan {
    color: #9191A4;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%;
  }

  &__value {
    color: #00031F;
    font-size: 16px;
    font-style: normal;
    font-weight: 450;
    line-height: 150%;
  }
}
</style>
